//@flow
import {
  UploadFromUrlResponse,
  UploadFromUrlQuery,
  UploadFromUrlMessage,
  UploadFromUrlItem,
} from '../../autogenerated/ZoomBridge';
import ErrorId from '../../protocol/ErrorId';
import HashMap from '../../protocol/HashMap';

export default class UploadFromUrl {
  static SKIP: string = 'SKIP';
  static REPLACE: string = 'REPLACE';
  static ABORT: string = 'ABORT';
  _message: UploadFromUrlMessage;

  constructor() {}

  addPath(paths: Array<string>, destinationDir: string, duplicateDetect: string): void {
    const message = new UploadFromUrlMessage();
    message.setAction('url-upload');
    message.setPaths(paths);
    const env = new HashMap();
    env.put('duplicateDetect', duplicateDetect);
    env.put('destinationDir', destinationDir);
    message.setProperties(env);
    this._message = message;
  }

  addS3(
    bucketName: string,
    path: string,
    accessId: String,
    secretKey: string,
    duplicateDetect: string,
    destinationDir: string,
    awsRegion: string
  ): void {
    const message = new UploadFromUrlMessage();
    message.setAction('s3-upload');
    message.setPaths([path]);
    const env = new HashMap();
    env.put('duplicateDetect', duplicateDetect);
    env.put('destinationDir', destinationDir);
    env.put('accessId', accessId);
    env.put('secretKey', secretKey);
    env.put('bucketName', bucketName);
    env.put('region', awsRegion);
    message.setProperties(env);
    this._message = message;
  }

  /**
   * @private
   */
  _doRun(): Promise<UploadFromUrlResponse> {
    const query: UploadFromUrlQuery = new UploadFromUrlQuery();
    const message = this._message;
    query.message = message;
    return query.run();
  }

  run(): Promise<UploadFromUrlResponse> {
    return this._doRun();
  }
}
